/**
 * 驗證傳入的字串是否為公司 Email 格式（@gmail.com、@yahoo.com、@hotmail.com 以外的 Email）
 * @param payload: String
 * @returns Boolean
 */

const validateCompanyEmail = (payload: string): boolean => {
  const regex: RegExp =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const result: boolean = regex.test(payload);

  if (result) {
    const plainText: string = payload.toLowerCase();
    const emailList: string[] = ['@gmail.com', '@yahoo.com', '@hotmail.com'];
    return !emailList.some((item) => plainText.includes(item));
  }
  return result;
};

export default validateCompanyEmail;
